<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-form label-width="120px">
      <el-form-item label="资讯标题：">
        <el-input
            style="width: 600px;"
            placeholder="请输入"
            v-model="formData.title"
        />
      </el-form-item>
      <el-form-item label="正文：">
        <my-edit v-model="formData.content" type="1" />
      </el-form-item>
	  <br>
      <el-form-item label="设置封面：">
        <!-- 图片上传 -->
        <more-img v-model="formData.coverImgs" type="1" ref='ch' :total="1" />

      </el-form-item>
     <!-- <el-form-item label="频道分类：">
        <el-select v-model="formData.tagsId" class="w300" clearable @change="tagChange">
          <el-option v-for="(item, index) in tagList" :key="index" :label="item.tagsName" :value="item.tagsId"/>
        </el-select>
      </el-form-item>
      <el-form-item label="标签：">
        <el-select v-model="formData.labelId" class="w300" multiple placeholder="请选择">
          <el-option
              v-for="item in labelList"
              :key="item.labelId"
              :label="item.labelName"
              :value="item.labelId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否置顶：">
        <el-radio v-model="formData.top" label="Y">是</el-radio>
        <el-radio v-model="formData.top" label="N">否</el-radio>
      </el-form-item>
      <el-form-item label="置顶位置" v-if="formData.top == 'Y'">
        <el-radio-group v-model="formData.radio">
          <el-radio label="1">全国置顶1</el-radio>
          <el-radio label="2">全国置顶2</el-radio>
          <el-radio label="3">全国置顶3</el-radio>
          <el-radio label="4">全国置顶4</el-radio>
          <el-radio label="5">全国置顶5</el-radio>
        </el-radio-group>
        <div class="mt10">
          <el-radio v-model="formData.radio" label="6">区域置顶</el-radio>

          <el-cascader
              ref="refTopCity"
              style="width: 500px;"
              v-show="formData.radio == '6'"
              v-model="formData.city"
              :options="cityList"
              :props="{value: 'code', label: 'name', multiple: true}"
              clearable
          />
        </div>
      </el-form-item>
      <el-form-item label="置顶日期" v-if="formData.top == 'Y'">
        <el-date-picker
            v-model="formData.date"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item label="消息推送：">
        <el-radio v-model="formData.pushFlag" :label="true">是</el-radio>
        <el-radio v-model="formData.pushFlag" :label="false">否</el-radio>
      </el-form-item> -->

      <el-form-item class="mt55">
        <el-button type="primary" @click="save">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {
    yDProductDetailAddOrEdit,
	  
    getInformationClassify,
    getInformationTagsByClassify,
    getInformationCityTreeByUserRole,
    addInformationMine,
    getInformationAuditMsg
  } from '@/api'

  import MyEdit from '@/components/MyEdit'
  import MoreImg from '@/components/yDProductImg'

  export default {
    name: 'InformationEdit',
    components: {MyEdit, MoreImg},
    data () {
      return {
        formData: {
          title: '',
          context: '',
          tagsId: '',
          coverImgs: [],
          labelId: [],
          pushFlag: true,
          date: [],
          radio: '1',
          top: 'Y'
        },
        labelList: [],
        tagList: [],
        cityList: [],
      }
    },
    created () {
      //this.getInformationClassifyFn()
      //this.getInformationCityTreeByUserRoleFn()

      this.$route.query.id && this.getInformationAuditMsgFn(this.$route.query.id)
    },
    methods: {
      save () {
        //let chil = this.$refs.ch;
        //console.info(chil.tempList,"图片上传处理结果"); 
        //console.info(chil.tempList[0].url,"==url");
        //console.info(this.formData.coverImgs[0],"==this.formData.coverImgs[0]");
        let temp = {
          title: this.formData.title,
          content: this.formData.content,
          cover: this.formData.coverImgs[0]
        }	
		yDProductDetailAddOrEdit(temp).then(res => {
		 this.$message.success(res.msg)
		 this.$router.push('/information/platform')
		})
	
      },
      tagChange (val) {
        if (val) {
          this.formData.labelId = []
          this.labelList = []
          getInformationTagsByClassify(val).then(res => {
            this.labelList = res.data
          })
        }
      },
      getInformationClassifyFn () {
        getInformationClassify().then(res => {
          this.tagList = res.data
        })
      },
      getInformationCityTreeByUserRoleFn () {
        getInformationCityTreeByUserRole().then(res => {
          this.cityList = res.data
        })
      },
      getInformationAuditMsgFn (id) {
        getInformationAuditMsg(id).then(res => {
          let temp = Object.assign({}, res.data)
          this.formData = {
            title: temp.title,
            context: temp.context,
            tagsId: temp.tagsId,
            coverImgs: temp.cover || [],
            labelId: temp.labelIdList || [],
            pushFlag: true,
            date: [],
            radio: '1'
          }
        })
      },
    }
  }
</script>

<style scoped>
</style>
